<template>
  <div class="car-archive-details">
    <div class="car-archive-details-content">
      <div class="car">
        <div class="row">
          <div v-for="(i, index) in baseInfo" :key="index">
            <span>{{ i.name }}</span>
            <span>{{ i.value }}</span>
          </div>
        </div>
      </div>
      <div class="vin">
        <div class="search-warehouse">
          <div class="screen">
            <el-select class="white w200" clearable v-model="search.collectStatus" placeholder="请选择采集状态">
              <el-option v-for="item in collectStatusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-select class="white w200" clearable v-model="search.vehicleStatus" placeholder="请选择车辆情况">
              <el-option
                v-for="item in vehicleConditionList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-button class="btn-blue" @click="onSearch">搜索</el-button>
          </div>
        </div>
        <div class="table">
          <el-table ref="table" :data="tableList" style="width: 100%">
            <el-table-column 
              v-for="(item, index) in tableTitleList"
              :key="index"
              :label="item.label"
              :prop="item.prop"
            >
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button class="btn-text" type="text" @click="lookDetails(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="footer">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { modifyNetTitle, formaTimeToAllSecond } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {

  data() {
    return {
      baseInfo: [
        {name: '批次号：', value: ''},
        {name: '作业类型：', value: ''},
        {name: '品牌：', value: ''}
      ],
      search: {
        collectStatus: '',
        vehicleStatus: ''
      },
      collectStatusList: [
        {id:0, name: '未采集'},
        {id:1, name: '已采集'}
      ],
      tableList: [],
      tableTitleList: [
        {label: '车架号', prop: 'vin'},
        {label: '采集状态', prop: 'collectStatusVal'},
        {label: '采集时间', prop: 'submitTime'},
        {label: '车辆情况', prop: 'vehicleConditionVal'}
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      vehicleConditionList: [
        {id:0, name: '正常'},
        {id:1, name: '有质损'}
      ],
    }
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('采集看板详情')
    this.initDetails()
  },

  methods: {
    initDetails() {
      const id = Number(this.$route.query.id)
      let data = this.search
      data.pageNo = this.currentPage
      data.pageSize = this.pageSize
      SmartVehicleInspection.getKanbanDetails(id, data).then(res => {
        if (res.success) {
          const { records, total, size } = res.result
          let baseInfoObj = this.$route.query
          this.baseInfo = [
            {name: '批次号：', value: baseInfoObj.batchNo},
            {name: '作业类型：', value: baseInfoObj.assignmentTypeVal},
            {name: '品牌：', value: baseInfoObj.brandName}
          ]
          this.pageSize = size;
          this.total = total;
          let arr = [];
          records.map(value => {
            let obj = {};
            obj.id = value.recordId;
            obj.vin = value.vin;
            obj.submitTime = value.submitTime ? formaTimeToAllSecond(value.submitTime) : '-';
            obj.vehicleStatus = value.vehicleStatus;
            obj.vehicleConditionVal = typeof value.vehicleStatus === 'number' ? value.vehicleStatus === 0 ? '正常' : '有质损' : '-';
            obj.collectStatus = value.collectStatus;
            obj.collectStatusVal = value.collectStatus === 1?'已采集':'未采集';
            arr.push(obj);
          });
          this.tableList = arr;
        }
      })
    },

    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initDetails();
    },

    onSearch() {
      this.initDetails()
    },

    lookDetails(row) {
      this.$router.push({
        path: '/vehicle/homework-center/archive/car-archive-details',
        query: {
          id: row.id,
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.car-archive-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .car-archive-details-content {
    height: 100%;
    padding: 24px 30px;
    background: #fff;
    border-radius: 8px;
    .car {
      width: 100%;
      border-bottom: 1px solid #eee;
      padding-bottom: 24px;
      margin-bottom: 24px;
      .row {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        row-gap: 24px;
        column-gap: 24px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
    .vin {
      .search-warehouse {
        margin-bottom: 16px;
        .screen {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .w200 {
            width: 200px;
            margin-right: 16px;
          }
        }
      }
      
      .footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 16px;
      }
    }
  }
}
</style>
